import React, { createContext, useContext } from 'react';

/**
 * ShoppingCartContext
 * - shoppingCart 데이터
 * - 장바구니 상태
 */
const ShoppingCartContext = createContext(null);

/**
 * ShoppingCartProvider
 * @param {Object} value - useShoppingCart hook의 반환값
 */
export const ShoppingCartProvider = ({ children, value }) => {
  return <ShoppingCartContext.Provider value={value}>{children}</ShoppingCartContext.Provider>;
};

/**
 * useShoppingCartContext
 * - ShoppingCartProvider 내부에서만 사용 가능
 * - shoppingCart 등 반환
 */
export const useShoppingCartContext = () => {
  const context = useContext(ShoppingCartContext);
  if (!context) {
    throw new Error('useShoppingCartContext는 ShoppingCartProvider 내부에서 사용해야 합니다');
  }
  return context;
};

export default ShoppingCartContext;
